import { gozokiApiWithAuth } from '../gozokiApi'

// Destroy a store
export const destroyStore = async (id: number) => {
  const response = await gozokiApiWithAuth.delete(`/stores/${id}`)
  return response
}

// Destroy multiple stores
export const destroyStores = async (ids: number[]) => {
  const responses = await Promise.all(ids.map((id) => destroyStore(id)))
  return responses
}

export const refreshStocks = async () => {
  const response = await gozokiApiWithAuth.post(`/sync/stock`)
  return response
}

export const refreshBearcod = async () => {
  const response = await gozokiApiWithAuth.post(`/sync/update-bearcod`)
  return response
}

export const cleanStoreArticles = async (id: number) => {
  const response = await gozokiApiWithAuth.post<number>(`/stores/${id}/clean-articles`)
  return response
}

export const downloadAdminXlsx = async ({
  dateStart,
  dateEnd,
  storeId,
}: {
  dateStart: string
  dateEnd: string
  storeId?: number
}) => {
  const response = await gozokiApiWithAuth.get(
    `/stores/get-audit-xlsx/${dateStart}/${dateEnd}${storeId ? `?storeId=${storeId}` : ''}`,
    {
      responseType: 'blob',
    },
  )
  return response
}

export const downloadWeeklyAuditAdminXlsx = async ({
  dateStart,
  dateEnd,
  storeId,
}: {
  dateStart: string
  dateEnd: string
  storeId?: number
}) => {
  const response = await gozokiApiWithAuth.get(
    `/stores/get-weekly-audit-xlsx/${dateStart}/${dateEnd}${storeId ? `?storeId=${storeId}` : ''}`,
    {
      responseType: 'blob',
    },
  )
  return response
}

export const downloadDeliveryReport = async ({
  dateStart,
  dateEnd,
  storeId,
}: {
  dateStart: string
  dateEnd: string
  storeId?: number
}) => {
  const params = new URLSearchParams()
  if (storeId) {
    params.append('storeId', storeId.toString())
  }
  const queryString = params.toString()
  const response = await gozokiApiWithAuth.get(
    `/stores/get-delivery-report/${dateStart}/${dateEnd}${queryString ? `?${queryString}` : ''}`,
    {
      responseType: 'blob',
    },
  )
  return response
}

export const downloadPaymentsCsv = async ({
  dateStart,
  dateEnd,
}: {
  dateStart: string
  dateEnd: string
}) => {
  const response = await gozokiApiWithAuth.get(
    `/stores/get-payments-xlsx/${dateStart}/${dateEnd}`,
    {
      responseType: 'blob',
    },
  )
  return response
}

export const downloadSupplyReport = async ({
  dateStart,
  dateEnd,
}: {
  dateStart: string
  dateEnd: string
}) => {
  const response = await gozokiApiWithAuth.get(`/stores/supply-report/${dateStart}/${dateEnd}`, {
    responseType: 'blob',
  })
  return response
}

export const downloadStockAuditCsv = async (id: number) => {
  const response = await gozokiApiWithAuth.get(`/stores/${id}/get-stock-audit-csv`, {
    responseType: 'blob',
  })
  return response
}

export const rebootCpiKiosk = async (kioskId: string) => {
  const response = await gozokiApiWithAuth.post(`/stores/reboot-kiosk/${kioskId}`)
  return response
}

export const downloadTicketsCsv = async ({
  dateStart,
  dateEnd,
  storeId,
}: {
  dateStart: string
  dateEnd: string
  storeId?: number | null
}) => {
  const response = await gozokiApiWithAuth.get('/stores/get-all-tickets-xlsx', {
    params: {
      startDate: dateStart,
      endDate: dateEnd,
      ...(storeId ? { storeId } : {}),
    },
    responseType: 'blob',
  })
  return response
}

export const mooveArticlesBetweenStores = async ({
  originId,
  destinationId,
  articlesIds,
  allArticles,
}: {
  originId: number
  destinationId: number
  articlesIds?: number[]
  allArticles?: boolean
}) => {
  const response = await gozokiApiWithAuth.post(`/stores/moove-articles`, {
    allArticles,
    articlesIds,
    destinationId,
    originId,
  })
  return response
}

export const importReapproNeedModifications = async ({
  file,
  categoryId,
}: {
  file: File
  categoryId: number
}) => {
  const formData = new FormData()
  formData.append('importFile', file)
  formData.append('reapproCategoryId', String(categoryId))

  const response = await gozokiApiWithAuth.post<{
    updated: number
    deleted: number
    errors: string[]
  }>('/stores/reappro-needs/import-modifications', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export const importReapproNeedModificationsBulk = async (file: File) => {
  const formData = new FormData()
  formData.append('importFile', file)

  const response = await gozokiApiWithAuth.post<{
    updated: number
    unchanged: number
    rejected: number
    errors: { reference: string; message: string }[]
  }>('/stores/reappro-needs/import-modifications-bulk', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}
